import React from 'react';
import { Route, Switch } from 'react-router-dom';

import  ListEmployee from './list';
import  EditEmployee  from './edit';

function Employee({ match }) {
    const { path } = match;
    console.log(999,"hola");
    return (
        <Switch>
            <Route exact path={path} component={ListEmployee} />
            <Route path={`${path}/add`} component={EditEmployee} />
            <Route path={`${path}/edit/:id`} component={EditEmployee} />
        </Switch>
    );
}

export { Employee };